/**
 * Do not edit directly
 */
export const lightTheme = {
  "semantic": {
    "brand": {
      "default": {
        "primary": "#1659cb",
        "secondary": "#1890ff",
        "subtle": "#eff6ff",
        "muted": "#dbeafe",
        "light": "#c5e3ff",
        "soft": "#bae7ff",
        "moderate": "#4abfe5",
        "strong": "#065492"
      },
      "danger": {
        "primary": "#ef4444",
        "inverse": "#fef2f2",
        "subtle": "#fee2e2",
        "light": "#fecaca",
        "muted": "#fca5a5"
      }
    },
    "text": {
      "primary": "#111111",
      "secondary": "#333333",
      "tertiary": "#666666",
      "subtle": "#d9d9d9",
      "soft": "#a3a3a3",
      "inverse": "#fafafa",
      "highlight": "#eed3ab"
    },
    "background": {
      "neutral": {
        "primary": "#f5f4f2",
        "secondary": "#ffffff",
        "subtle": "#fafafa",
        "soft": "#e5e5e5",
        "strong": "#979797",
        "strongL1": "#666666",
        "strongL2": "#404040",
        "inverse": "#0f1e37"
      },
      "highlight": {
        "primary": "#f4f9fa",
        "secondary": "#eed3ab"
      }
    },
    "border": {
      "primary": "#d9d9d9",
      "secondary": "#333333",
      "subtle": "#f5f4f2",
      "strong": "#a3a3a3",
      "soft": "#f5f5f5",
      "inverse": "#ffffff"
    },
    "accent": {
      "cyan": {
        "subtle": "#f4f9fa",
        "soft": "#cffafe",
        "muted": "#a5f3fc",
        "moderate": "#67e8f9",
        "bold": "#22d3ee",
        "strong": "#06b6d4",
        "primary": "#0e7490",
        "inverse": "#164e63"
      },
      "tan": {
        "subtle": "#f9f9f9",
        "soft": "#f5f5f5",
        "muted": "#eed3ab",
        "strong": "#d4c5a9"
      },
      "inverse": {
        "subtle": "#065492",
        "soft": "#1d4ed8",
        "strong": "#1659cb",
        "primary": "#1e3a8a",
        "secondary": "#000000",
        "inverse": "#1e40af"
      },
      "green": {
        "subtle": "#f0fdf4",
        "soft": "#dcfce7",
        "muted": "#86efac",
        "bold": "#4ade80",
        "strong": "#20b249",
        "primary": "#15803d",
        "inverse": "#14532d"
      },
      "orange": {
        "subtle": "#fff7ed",
        "soft": "#ffedd5",
        "muted": "#fdba74",
        "strong": "#fb923c",
        "primary": "#c2410c",
        "inverse": "#7c2d12"
      },
      "purple": {
        "subtle": "#faf5ff",
        "soft": "#f3e8ff",
        "muted": "#d8b4fe",
        "bold": "#c084fc",
        "strong": "#9333ea",
        "primary": "#7c3aed",
        "inverse": "#581c87"
      },
      "blue": {
        "subtle": "#eff6ff",
        "soft": "#dbeafe",
        "muted": "#93c5fd",
        "bold": "#60a5fa",
        "strong": "#1659cb",
        "primary": "#065492",
        "inverse": "#1e3a8a"
      },
      "yellow": {
        "subtle": "#fefce8",
        "soft": "#fef9c3",
        "bold": "#facc15",
        "muted": "#facc15",
        "strong": "#ca8a04",
        "primary": "#854d0e",
        "inverse": "#713f12"
      },
      "red": {
        "subtle": "#fef2f2",
        "soft": "#fee2e2",
        "muted": "#fca5a5",
        "bold": "#f87171",
        "strong": "#dc2626",
        "primary": "#b91c1c",
        "inverse": "#7f1d1d"
      },
      "pink": {
        "subtle": "#fdf2f8",
        "soft": "#fce7f3",
        "muted": "#f9a8d4",
        "bold": "#f472b6",
        "strong": "#db2777",
        "primary": "#be185d",
        "inverse": "#831843"
      }
    }
  }
};
